import React, { useState } from 'react'

function truncateEmail(email) {
  return email.length > 35 ? email.slice(0, 34) + '…' : email
}

export function ProcessorEmailList({ emails = [], submitted, applicantStatus, processorTag }) {
  const [open, setOpen] = useState(false)
  const count = emails.length

  return (
    <div style={{ marginTop: 12, borderTop: '1px solid #DBDBDB', paddingTop: 6 }}>
      <button
        type="button"
        className="dome-d-flex dome-align-center dome-gap6"
        style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer' }}
        onClick={() => setOpen((o) => !o)}
      >
        <i className="fa-solid fa-xs fa-user dome-color-dark-grey" />
        <span className="dome-p2 dome-color-dark-grey">{processorTag} processors</span>
        <span className="dome-p2 dome-color-aqua">({count})</span>
        <i
          className="fa-solid fa-xs fa-chevron-down dome-color-dark-grey"
          style={{ transform: open ? 'rotate(180deg)' : undefined }}
        />
      </button>
      {open && (
        <div style={{ padding: '4px 18px 0' }}>
          {count === 0 ? (
            <span className="dome-p2 dome-color-med-grey">No processors assigned yet.</span>
          ) : (
            <div className="dome-d-flex dome-flex-column">
              {emails.map((p) => (
                <div key={p.email} className="dome-d-flex dome-gap24 dome-align-start">
                  <span
                    style={{ width: 200, flexShrink: 0, overflowWrap: 'anywhere' }}
                    className="dome-p2 dome-color-dark-grey"
                  >
                    {p.name}
                  </span>
                  <span
                    style={{ flexGrow: '1', overflowWrap: 'anywhere' }}
                    className="dome-p2 dome-color-dark-grey "
                    title={p.email}
                  >
                    {truncateEmail(p.email)}
                  </span>
                </div>
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  )
}

export default ProcessorEmailList
